import { render } from "./DiscoverFilterModal.vue?vue&type=template&id=e8a5b592&scoped=true"
import script from "./DiscoverFilterModal.vue?vue&type=script&lang=js"
export * from "./DiscoverFilterModal.vue?vue&type=script&lang=js"

import "./DiscoverFilterModal.vue?vue&type=style&index=0&id=e8a5b592&lang=css&scoped=true"
import "@vueform/slider/themes/default.css?vue&type=style&index=1&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8a5b592"]])

export default __exports__